import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

/**
 * Definition list skeleton loading component.
 * Simplified: title bar + a few varied-width shimmer lines.
 * Supports dark mode and respects prefers-reduced-motion.
 */
@Component({
  selector: 'app-dl-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dl-skeleton" role="status" aria-label="Loading data">
      <div class="dl-skeleton__title"></div>
      <div class="dl-skeleton__line" style="width: 90%"></div>
      <div class="dl-skeleton__line" style="width: 65%"></div>
      <div class="dl-skeleton__line" style="width: 80%"></div>
      @if (rows() > 4) {
        <div class="dl-skeleton__line" style="width: 50%"></div>
      }
      <span class="visually-hidden">Loading...</span>
    </div>
  `,
  styles: [`
    .dl-skeleton {
      width: 100%;
      padding: var(--space-md, 16px) 0;
    }

    .dl-skeleton__title {
      width: 30%;
      height: 14px;
      margin-bottom: var(--space-lg, 24px);
      border-radius: var(--radius-sm, 4px);
      background: linear-gradient(
        90deg,
        var(--gokuri-skeleton-base, #f0f0f0) 25%,
        var(--gokuri-skeleton-highlight, #e0e0e0) 50%,
        var(--gokuri-skeleton-base, #f0f0f0) 75%
      );
      background-size: 200% 100%;
      animation: shimmer var(--gokuri-skeleton-animation-duration, 1.5s) ease-in-out infinite;
    }

    .dl-skeleton__line {
      height: 12px;
      margin-bottom: var(--space-md, 16px);
      border-radius: var(--radius-sm, 4px);
      background: linear-gradient(
        90deg,
        var(--gokuri-skeleton-base, #f0f0f0) 25%,
        var(--gokuri-skeleton-highlight, #e0e0e0) 50%,
        var(--gokuri-skeleton-base, #f0f0f0) 75%
      );
      background-size: 200% 100%;
      animation: shimmer var(--gokuri-skeleton-animation-duration, 1.5s) ease-in-out infinite;
    }

    @keyframes shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }

    @media (prefers-reduced-motion: reduce) {
      .dl-skeleton__title,
      .dl-skeleton__line {
        animation: none;
        background: var(--gokuri-skeleton-base, #f0f0f0);
      }
    }

    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
  `]
})
export class DlSkeletonComponent {
  /** Hint for content density — >4 adds an extra line */
  readonly rows = input(4);
}
